import { useSelector } from 'react-redux';
import * as normalBotFlowActions from '../reducers/canvas/canvasSlice';
import * as wcaBotFlowActions from '../reducers/wca/botflow/botflow-slices';

export const selectIsWcaBotFlow = (state) =>
  state.authenticate?.companyConfigData?.wabaPartner === 'skalebot';

export const selectActiveBotFlowState = (state) =>
  selectIsWcaBotFlow(state) ? state.wcaBotFlow : state.canvas;

export const useActiveBotFlowActions = () => {
  const isWcaBotFlow = useSelector(selectIsWcaBotFlow);
  return isWcaBotFlow ? wcaBotFlowActions : normalBotFlowActions;
};
